import { MutationOptions } from '@tanstack/react-query';

import { AxiosCartError, Cart, MigrateCartParams } from '@telialt/models/src/EshopModel';
import { DDComponent } from '@telialt/utils/src/datadog/setup';
import { useLogError } from '@telialt/utils/src/datadog/useLogError';
import {
    PARAM_SERVICE_SO_ID_QUERY,
    PARAM_SERVICE_UO_ID_QUERY,
    PARAM_SERVICE_UO_TYPE_QUERY,
    PARAM_TYPE_QUERY,
} from '@telialt/utils/src/eshopConstants';
import QueryString from '@telialt/utils/src/QueryString';
import { useSegment } from '@telialt/utils/src/segment';

import { ESHOP_MUTATION_KEY } from '../../model';
import { apiMigrateCart } from '../../store/api';
import { useMutationWithCartRefresh } from './useMutationWithCartRefresh';

type Config = Omit<MutationOptions<Cart, AxiosCartError, MigrateCartParams>, 'mutationKey' | 'mutationFn'>;

export const useMigrateCartMutation = (config?: Config) => {
    const { search } = window.location;
    const type = new QueryString(search).getParam(PARAM_TYPE_QUERY);
    const serviceUoId = new QueryString(search).getParam(PARAM_SERVICE_UO_ID_QUERY);
    const serviceSoId = new QueryString(search).getParam(PARAM_SERVICE_SO_ID_QUERY);
    const serviceUoType = new QueryString(search).getParam(PARAM_SERVICE_UO_TYPE_QUERY);
    const segment = useSegment();

    const { mutate, isPending, isError, error, status } = useMutationWithCartRefresh(
        async ({ oldCartId }) =>
            (await apiMigrateCart(segment, { oldCartId, type, serviceUoId, serviceSoId, UOType: serviceUoType })).data,
        { ...config, mutationKey: [ESHOP_MUTATION_KEY.MIGRATE_CART] },
    );
    useLogError(error, DDComponent.Eshop);

    return {
        migrateCart: mutate,
        migrateCartError: error,
        isErrorMigrateCart: isError,
        isLoadingMigrateCart: isPending,
        statusMigrateCart: status,
    };
};
